import { render, staticRenderFns } from "./noDisc.vue?vue&type=template&id=48854302&scoped=true&"
import script from "./noDisc.vue?vue&type=script&lang=js&"
export * from "./noDisc.vue?vue&type=script&lang=js&"
import style0 from "./noDisc.vue?vue&type=style&index=0&id=48854302&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48854302",
  null
  
)

export default component.exports